module.exports = __webpack_public_path__ + "img/right-line.afd8f17a.svg";